<template>
  <d-modal
    @close="handleClose"
    size="lg">
    <d-modal-header>
      <d-modal-title>
        Add new crew
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <crew-form
        :isPopup="true"
        :customerID="customerID" />
    </d-modal-body>
  </d-modal>
</template>

<script>
import CrewForm from './../forms/CrewForm.vue';

export default {
  name: 'add-crew-popup',
  props: [
    'customerID'
  ],
  components: {
    'crew-form': CrewForm
  },
  methods: {
    handleClose () {
      this.$bus.$emit('add-crew-popup-close');
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
